import React, { useCallback, useState } from 'react';

import { ReactComponent as HelpIcon } from 'assets/icons/help.svg';
import { ReactComponent as CopyIcon } from 'assets/icons/copy.svg';

import { ListItemText, Menu, MenuItem } from '@mui/material';

import useStyles from 'components/HelpMenu/styles';
import { enqueueSnackbar } from 'notistack';

export const supportEmail: string = 'help@support.mspprocess.com';
export const knowledgeBaseLink: string = 'https://kb.mspprocess.com/';

const HelpMenu: React.FC = () => {
  const [anchorEl, setAnchorEl] = useState<null | SVGSVGElement>(null);
  const open = Boolean(anchorEl);

  const classes = useStyles();

  const handleClose = (): void => {
    setAnchorEl(null);
  };

  const handleClick = (event: React.MouseEvent<SVGSVGElement>): void => {
    setAnchorEl(event.currentTarget);
  };

  const handleMailToSupport = useCallback((e: React.MouseEvent<HTMLLIElement>): void => {
    window.location.href = `mailto:${supportEmail}`;
    e.preventDefault();
  }, []);

  const handleCopyEmail = useCallback((e: React.MouseEvent<SVGSVGElement>): void => {
    e.stopPropagation();
    e.preventDefault();
    window.navigator.clipboard.writeText(supportEmail);
    enqueueSnackbar('Copied to clipboard', { variant: 'success' });
    handleClose();
  }, []);

  const handleNavigateToKnowledgeBase = useCallback(() => {
    window.open(knowledgeBaseLink, '_blank');
  }, []);

  return (
    <>
      <HelpIcon onClick={handleClick} />

      <Menu open={open} onClose={handleClose}>
        <MenuItem onClick={handleNavigateToKnowledgeBase}>
          <ListItemText>Knowledge Base</ListItemText>
        </MenuItem>

        <MenuItem onClick={handleMailToSupport}>
          <ListItemText>Support</ListItemText>

          <CopyIcon className={classes.icon} onClick={handleCopyEmail} />
        </MenuItem>
      </Menu>
    </>
  );
};

export default HelpMenu;
